import type { MantineThemeOverride } from "@mantine/core";

import type { WhitelabelBrandTheme } from "@/configs/whitelabel";

export const defaultWhitelabelTheme: MantineThemeOverride = {
  // prettier-ignore
  colors: {
    primary: ["#e7e9eb","#cfd2d7","#b7bcc3","#9fa6af","#87909b","#6e7987","#566373","#3e4d5f","#26364b","#0e2037"],
    secondary: ["#f6fbf8","#eef8f1","#e5f4ea","#dcf1e3","#d4eddc","#cbe9d4","#c2e6cd","#b9e2c6","#b1dfbf","#a8dbb8"],
  },
  other: {
    logo: "/storage/v1/object/public/whitelabel/waku/logo.png", // Supabase Storage URI (without prefix)
    logoLocal: "/whitelabel/waku/logo.png", // src/public/...
  },
};

// prettier-ignore
export const whitelabelThemes: Record<WhitelabelBrandTheme, MantineThemeOverride> = {
  waku: defaultWhitelabelTheme,
  logisticsag: {
    colors: {
      primary: ["#fbe9ed", "#f7d3da","#f3bdc8","#efa7b5", "#eb91a3","#e67a90","#e2647e","#de4e6b","#da3859","#d62246"],
      secondary: ["#e8f9f8","#d1f2f1","#b9eceb","#a2e5e4","#8bdfdd","#74d8d6","#5dd2cf","#45cbc9","#2ec5c2","#17bebb"],
    },
    other: {
      logo: '/storage/v1/object/public/whitelabel/logistics-ag/logo.png', // Supabase Storage URI (without prefix)
      logoLocal: '/whitelabel/logistics-ag/logo.png', // src/public/...
    }
  },
  meili: {
    colors: {
      primary: [ "#f0e7f4", "#e1cfea", "#d2b7df", "#c39fd5", "#b487ca", "#a46ebf", "#9556b5", "#863eaa", "#7726a0", "#680e95" ],
      secondary: [ "#f7eefe", "#efddfc", "#e6ccfb", "#debbf9", "#d6aaf8", "#ce99f7", "#c688f5", "#bd77f4", "#b566f2", "#ad55f1" ],
    },
    other: {
      logo: '/storage/v1/object/public/whitelabel/meili/logo.png', // Supabase Storage URI (without prefix)
      logoLocal: '/whitelabel/meili/logo.png', // src/public/...
    }
  },
  hai: {
    colors: {
      primary: [ "#eaeaff", "#d5d6fe", "#c0c1fe", "#abadfd", "#9798fd", "#8283fc", "#6d6ffc", "#585afb", "#4346fb", "#2e31fa" ],
      secondary: [ "#f3f4fe", "#e8e8fe", "#dcddfd", "#d1d1fc", "#c5c6fc", "#b9bafb", "#aeaffa", "#a2a3f9", "#9798f9", "#8b8cf8" ],
    },
    other: {
      logo: '/storage/v1/object/public/whitelabel/hai/logo.png', // Supabase Storage URI (without prefix)
      logoLocal: '/whitelabel/hai/logo.png', // src/public/...
    }
  },
  safelog: {
    colors: {
      primary: [ "#e8e9e9", "#d1d2d3", "#bbbcbd", "#a4a6a7", "#8d9092", "#76797c", "#5f6366", "#494d50", "#32363a", "#1b2024" ],
      secondary: [ "#fdeee6", "#fbdecd", "#f9cdb4", "#f7bd9b", "#f5ac83", "#f29b6a", "#f08b51", "#ee7a38", "#ec6a1f", "#ea5906" ],
    },
    other: {
      logo: '/storage/v1/object/public/whitelabel/safelog/logo.png', // Supabase Storage URI (without prefix)
      logoLocal: '/whitelabel/safelog/logo.png', // src/public/...
    }
  },
};
